<button
  mat-icon-button
  [matMenuTriggerFor]="routeMenu"
  aria-label="Example icon-button with a menu"
>
  <mat-icon>menu</mat-icon>
</button>
<mat-menu #routeMenu="matMenu">
  @for (nav of fillerNav(); track nav) {
    <button mat-menu-item routerLink="." [routerLink]="nav.path">
      {{ nav.path }}
    </button>
  }
</mat-menu>
